
import { useCallback, useState, useEffect } from 'react';
import AsyncSelect from 'react-select/async';
import { Option } from '../../interface/Option';
import { IcdGr, Result } from '../../interface/ICD';
import { IcdAxiosInstance } from '../../Network/IcdAxiosInstance';

const ListOfCustomIcdGroups = ({ onChange, clear, defaultValue, reloadTrigger }: any) => {
  const [cacheOptions, setCacheOptions] = useState<{ [key: string]: Option[] }>({});
  const [selectedOptions, setSelectedOptions] = useState<Option[]>(defaultValue || []);
  const [inputKey, setInputKey] = useState(0); // To reset AsyncSelect

  const loadOptions = useCallback(
    async (inputValue: string): Promise<Option[]> => {
      try {
        const response = await IcdAxiosInstance.get<IcdGr>(`geticd/`);
        const data: Result[] = response.data.result;

        const options: Option[] = data.map((item: Result) => ({
          value: item.id,
          label: `${item.id}: ${item.custom_group_name}`, 
        }));
     
        // search
        const filteredOptions = options.filter((option: Option) =>
          option.label.toLowerCase().includes(inputValue.toLowerCase())
        );

        setCacheOptions((prevCache) => ({
          ...prevCache,
          [inputValue]: filteredOptions,
        }));

        return filteredOptions;
      } catch (error) {
        console.error("Error loading options:", error);
        return [];
      }
    },
    []
  );


  const handleChange = (newValue: any) => {
    setSelectedOptions(newValue || []); 
    onChange(newValue || []); 
  };

// Use `clear` to empty fields when needed
useEffect(() => {
    if (clear) {
      setSelectedOptions([]); 
      setCacheOptions({}); 
      setInputKey((prevKey) => prevKey + 1);
    }
  }, [clear]);

// Set the initial value when modifying
useEffect(() => {
    if (defaultValue) {
      setSelectedOptions(defaultValue); 
      setCacheOptions({}); 
      setInputKey((prevKey) => prevKey + 1); 
    }
  }, [defaultValue]);

// Reload options when a change occurs after adding or deleting
  useEffect(() => {
    if (reloadTrigger) {
      setCacheOptions({});
      setInputKey((prevKey) => prevKey + 1); 
    }
  }, [reloadTrigger]); // Call reload when `reloadTrigger` is changed

  return (
    <AsyncSelect
      key={inputKey} 
      cacheOptions
      className="controlWidth mb-3"
      isMulti
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      loadOptions={loadOptions}
      onChange={handleChange}
      defaultOptions
      value={selectedOptions} 
      placeholder="Type characters to search..."
    />
    
  );
  
};

export default ListOfCustomIcdGroups;
